// extracted by mini-css-extract-plugin
export default {"figure":"styles_figure__ofKgA","fieldOverlay":"styles_fieldOverlay__gvY90"};